import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

/* Masthead — visual cousin of the main site's masthead. Auth-aware:
   shows email + sign-out when signed in, sign-in/sign-up when not. */
export function Masthead() {
  const navigate = useNavigate();
  const { user, loading, signOut } = useAuth();

  return (
    <header className="border-b border-rule">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-5 flex justify-between items-baseline gap-6 flex-wrap">
        <Link to="/" className="font-editorial text-[21px] font-medium tracking-tight text-ink no-underline">
          Ashutosh "Ash" Pandey
          <em className="not-italic text-ink-muted ml-1">
            <span className="italic">· CYBHI workspace</span>
          </em>
        </Link>

        <nav className="flex items-center gap-6 flex-wrap">
          <a
            href="https://prajnainnovates.com"
            className="font-label text-[12px] text-ink-soft no-underline hover:text-accent transition-colors"
          >
            ← prajnainnovates.com
          </a>

          {loading ? null : user ? (
            <div className="flex items-center gap-4">
              <span className="font-editorial italic text-[14px] text-ink-muted hidden sm:inline">
                {user.email}
              </span>
              <button
                type="button"
                onClick={async () => {
                  await signOut();
                  navigate('/');
                }}
                className="font-label text-[11px] font-medium uppercase tracking-[0.15em] text-link border-b border-accent-soft pb-0.5 hover:text-accent hover:border-accent transition-colors"
              >
                Sign out
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-5">
              <Link
                to="/signin"
                className="font-label text-[11px] font-medium uppercase tracking-[0.15em] text-ink-soft hover:text-accent transition-colors"
              >
                Sign in
              </Link>
              <Link
                to="/signup"
                className="font-label text-[11px] font-medium uppercase tracking-[0.15em] text-accent border-b border-accent-soft pb-0.5 hover:text-ink hover:border-ink transition-colors"
              >
                Create account
              </Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
